import { RhButton, RhLoader } from "@rhythm-ui/react";
import React from "react";

type ButtonProps = {
  loading?: boolean;
  disabled?: boolean;
  className?: string;
} & React.ComponentProps<typeof RhButton>;

const Button: React.FC<ButtonProps> = ({ loading, ...props }) => {
  return (
    <RhButton
      id="loader-button"
      {...props}
      className={`${props.className} relative`}
      disabled={loading || props.disabled}
    >
      <>
        <span className={`absolute ${!loading ? "hidden" : "left-0 right-0"}`}>
          <RhLoader size="sm" className="mx-auto" />
        </span>
        <span className={`${loading ? "invisible" : ""}`}>
          {props.children}
        </span>
      </>
    </RhButton>
  );
};

export default Button;
